import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Table, Loader} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import FilterSection from './filterSection';
import './agencies.scss';

class DealersAgencies extends Component {
  componentDidMount() {
    const {permissions} = this.props;

    if (!hasAccessPermission(permissions, resources.DealerAgencies, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.getAllAgencies();
  }

  renderAgencies() {
    const {agencies} = this.props;

    if (!agencies.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={13}>
            No hay datos disponibles con los filtros seleccionados
          </Table.Cell>
        </Table.Row>
      );
    }

    return agencies.map((agency, index) => {
      return (
        <Table.Row key={index} textAlign='center'>
          <Table.Cell>{agency.dealerName}</Table.Cell>
          <Table.Cell>{agency.code}</Table.Cell>
          <Table.Cell>{agency.description}</Table.Cell>
          <Table.Cell>{agency.phone}</Table.Cell>
          <Table.Cell>{agency.address}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderLoaderOrAgencies() {
    const {loadingAgencies} = this.props;

    if (loadingAgencies) {
      return (
        <Table.Row>
          <Table.Cell colSpan='5'>
            <Loader active inline='centered'>
              Consultando información...
            </Loader>
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderAgencies();
  }

  render() {
    return (
      <div className='dealer-agencies-catalog'>
        <Card raised fluid className='header'>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <h2>Agencias de Concesionarios</h2>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Card>
        <FilterSection />
        <Card raised fluid>
          <Table striped>
            <Table.Header>
              <Table.Row textAlign='center'>
                <Table.HeaderCell>Nombre</Table.HeaderCell>
                <Table.HeaderCell>Agencia</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Teléfono</Table.HeaderCell>
                <Table.HeaderCell>Dirección</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderLoaderOrAgencies()}</Table.Body>
          </Table>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.dealer.loadingAgencies,
    'agencies': state.dealer.filteredAgencies,
    'permissions': state.session.permissions,
  };
};

const {getAllAgencies, navigateTo} = Actions;

export default connect(mapStateToProps, {getAllAgencies, navigateTo})(
  DealersAgencies
);
